import React from 'react'
import ReactDOM from 'react-dom'

const captureSensitiveParams = () => {
  if (typeof window === 'undefined') return

  const currentPath = window.location.pathname
  const currentSearch = window.location.search

  if (currentPath === '/account/' && currentSearch.includes('GUID=')) {
    const url = new URL(window.location.href)
    const token = url.searchParams.get('GUID')

    if (token) {
      sessionStorage.setItem('reset_token', token)
    }

    url.searchParams.delete('GUID')
    window.history.replaceState({}, '', url.pathname + url.search)
  }
}

export const onInitialClientRender = async () => {
  captureSensitiveParams()

  if (process.env.NODE_ENV === 'development') {
    const { default: axe } = await import('@axe-core/react')
    await axe(React, ReactDOM, 1000, {})
  }
}

export const onRouteUpdate = () => {
  captureSensitiveParams()
}
